import React, { Component } from 'react';
import { dispatch, connect } from 'react-redux'
import { Grid, Row, Col, Jumbotron, Button } from 'react-bootstrap';
import { Redirect } from 'react-router';
import veri_sign from '../logo-verisign.png';
import inituit_logo from '../intuit-logo.png';
import { HashLink as Link } from 'react-router-hash-link';
import { clearUser} from '../actions/creators';
import TrustEBrandLogo from "./truste-brand-logo";



class welcome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nextPage:false
        };
    }

    btnTapped(e) {
        this.setState({nextPage:true})
    }

    signOut(e){
        this.props.clearUser(this.state);
    }

    render() {
        if(this.state.nextPage == true){
            if(this.props.returnStatus == "SIGNED"){
                return (<Redirect to="/review" />)
            }
            return (<Redirect to="/main_page" />)
        }

        if(this.props.login == "false"){
           return (<Redirect to="/sign_in" />)
        }
        return (
            <div>
                <Grid>
                    <Row>
                        <table className="user-details-table">
                            <tbody>
                            <td className="user-details">

                                <span className="user-details-info"><b>{this.props.userName}</b></span><br />
                                <span className="user-details-info"><b>{this.props.email}</b></span>

                                <br />
                                <Link to="/sign_out" onClick={e => this.signOut(e)}><font color="white" size="2"><u>sign out</u></font></Link>
                            </td>
                            </tbody>
                        </table>

                    </Row>
                    <Jumbotron className="logged-in">
                        <Row>
                            <Col className="divider" sm={1}>
                                {/*<SignInInfoForm/>*/}
                            </Col>
                            <Col sm={11}>
                                <div>
                                    <h5 ><font color="green"><b>Welcome {this.props.userName},</b></font></h5>
                                    <br />
                                </div>
                                <div>
                                    <font face="verdana" size="4">Your tax preparer has requested that you review the Benefit Plan tax documents<br /></font>
                                    <font face="verdana" size="4">prepared for your return. You'll then be asked to electronically sign your return, which<br /></font>
                                    <font face="verdana" size="4">will require your EFAST2 Userid and PIN.<br /></font>
                                    <br />
                                    <font face="verdana" size="4">Your information will be electronically submiited back to your tax preparer, but the<br /></font>
                                    <font face="verdana" size="4">preparer will NOT be able to see your Userid or PIN<br /></font>

                                </div>
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <button type="button" id="forward" name="forward" className="custom-btn" onClick={e => this.btnTapped(e)}><b>Let's Go</b></button>
                            </Col>
                            <br />
                        </Row>
                    </Jumbotron>
                    <Row>
                        <table className="logo-table">
                            <tbody>
                            <td className="left-brand-logo">
                                <img src={inituit_logo} alt="logo" width="120" height="40"/> <br/>
                                <Link to="/tnc" target="_blank"><font size="1.9" color="blue">Terms of
                                    Service</font></Link> |<a href="https://quickbooks.intuit.com/r/"
                                                              target="_blank"><font color="blue" size="1.75">
                                Privacy</font></a> <br/>
                                <font color="#00008b" size="1.75"> © 2019 Intuit Inc. All rights
                                    reserved.</font><br/>
                            </td>
                            <td className="right-brand-logo">
                                <TrustEBrandLogo />
                                <a href="https://sealinfo.verisign.com/splash?lang=en&dn=tax%2Design%2Eintuit%2Ecom&form%5Ffile=fdf%2Fsplash%2Efdf"
                                   target="_blank"> <img src={veri_sign} alt="logo" width="130" height="60"/></a>
                            </td>
                            </tbody>
                        </table>
                    </Row>
                </Grid>
            </div>
        );
    }
}



const mapStateToProps = ( state ) => {
    return {
        userName:state.userName,
        email:state.email,
        login:state.login,
        returnStatus:state.returnStatus,
        loginCount:state.loginCount
    }

};

const mapDispatchToProps = dispatch => {
    return {
        clearUser: (state) => {
            dispatch(clearUser(state))
        }
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(welcome);